import { ReactNode } from 'react';

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { IconDots } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { clsx } from 'clsx';

type ThreeDotOption = {
  onPress: () => void;
  title: string;
  isAlert?: boolean;
};

export type ThreeDotOptions = ThreeDotOption[];

export const ThreeDotOptionDropdown = ({
  options,
  className,
  icon = <IconDots />,
  theme = 'grey',
}: {
  options: ThreeDotOptions;
  className?: string;
  icon?: ReactNode;
  theme?: 'grey' | 'white';
}) => {
  return (
    <div className={className}>
      <Menu>
        <MenuButton
          className="border-0 bg-transparent p-0"
          data-testid="three-dot-option"
        >
          <Button
            variant="tertiary"
            type="button"
            size="small"
            iconOnly
            className={clsx('!h-[24px] w-[24px] p-0', {
              'm-0': theme === 'grey',
              'bg-transparent': theme === 'white',
            })}
          >
            {icon}
          </Button>
        </MenuButton>
        <MenuItems
          portal
          anchor="bottom end"
          className={clsx({
            'z-10 mt-xs w-[130px] rounded-s bg-black/60 p-s backdrop-blur-[5px]':
              theme === 'grey',
            'z-10 mt-xs w-[200px] rounded-s border border-secondary-80 bg-white':
              theme === 'white',
          })}
        >
          {options.map(({ onPress, title, isAlert = false }) => (
            <MenuItem key={title}>
              {() => (
                <button
                  className={clsx({
                    'rounded-s border-0 bg-transparent text-s font-med text-white hover:bg-black/30':
                      theme === 'grey',
                    'w-[200px] rounded-s border-transparent bg-white p-s text-left text-m font-med hover:bg-structure-95':
                      theme === 'white',
                    'text-core-30': isAlert,
                  })}
                  onClick={onPress}
                  type="button"
                >
                  {title}
                </button>
              )}
            </MenuItem>
          ))}
        </MenuItems>
      </Menu>
    </div>
  );
};
